<template>
  <i-modal
    :title="`${LANG.referencesOf} '${document.title || ''}'`"
    @openAutoFocus="fetchReferences"
  >
    <div class="references-wrapper">
      <div v-if="inboundReferences.length" class="inbound-references">
        <table class="filelist" cellpadding="0" cellspacing="0" width="100%">
          <caption>
            {{ LANG[`documentsReferencingThis${ac_enabled ? 'MediaFile' : 'Document'}`] }}
          </caption>
          <thead>
            <tr class="filelist-header">
              <th>{{ LANG.name }}</th>
              <th class="action-cell">{{ LANG.action }}</th>
              <th class="type-cell">{{ LANG.type }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(reference, idx) in inboundReferences" :key="idx">
              <td class="title-cell">
                <a
                  :href="reference.link"
                  :title="reference.title"
                  target="_blank"
                  class="i-css-ellipsis"
                  :aria-label="LANG.previewOpensBlank"
                  >{{ reference.title }}
                </a>
              </td>
              <td class="action-cell">
                <i-split-button class="wide-split-button">
                  <a class="main_split_button_action"
                    :aria-label="LANG.edit"
                    :href="uri('/document/archive/import', { __imperia_method: 'edit', __imperia_node_id: reference.node_id })"
                    target="_blank"
                  >
                    {{ LANG.edit }}
                  </a>
                  <template v-slot:dropdown="{close}">
                    <i-menu-list class="pull-right pull-top">
                      <i-menu-action
                        :label="LANG.information"
                        icon="info-circle"
                        :href="uri('/document/oce/info', { __imperia_node_id: reference.node_id })"
                        target="_blank"
                        @click="close"
                        :enabled="checkACL('/document/oce/info')"
                      />
                      <i-menu-action
                        :label="LANG.preview"
                        icon="eye"
                        :href="uri('/document/preview_url', { __imperia_url: reference.link })"
                        target="_blank"
                        :aria-label="LANG.previewOpensBlank"
                        @click="close"
                      />
                    </i-menu-list>
                  </template>
                </i-split-button>
              </td>
              <td class="type-cell">
                {{ formatType(reference.mimetype) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <template #footer>
      <div>
        <i-button
          variant="secondary"
          @click.prevent="$emit('update:show', false)"
        >
          {{ LANG.cancel }}
        </i-button>
      </div>
    </template>
  </i-modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import fetchService from '@/utils/model/fetch_service';
import globals from '@/globals';

const { uri } = globals.I.Util;
const remapReference = (ref) => (ref.copies && ref.copies.length ? ref.copies[0] : {});

export default {
  props: {
    document: {
      default: () => ({}),
      type: Object,
    },
    variant: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      references: {},
      ac_enabled: false,
    };
  },
  computed: {
    ...mapState(['LANG']),
    ...mapGetters(['checkACL']),
    inboundReferences() {
      return this.references.to
        ? this.references.to.map(remapReference)
        : [];
    },
  },
  methods: {
    async fetchReferences() {
      const params = {
        __imperia_node_id: this.document.nodeId,
        variant: this.variant,
      };
      const response = await fetchService.GetData(
        'docbrowser_references',
        params,
      );
      this.references = (response.data.refdata && response.data.refdata.finished) ? response.data.refdata.finished : {};
      this.ac_enabled = !!response.data.ac_enabled;
    },
    uri,
    formatType(type) {
      if (type === 'text/html') {
        return 'Imperia Document';
      }

      if (type.startsWith('image')) {
        return 'Media / Image';
      }

      if (type === 'application/pdf') {
        return 'Media / PDF';
      }

      return '-';
    },
  },
};
</script>

<style scoped lang='scss'>
.references-wrapper table td {
  padding: 0px;
  height: 40px;
  text-align: left;
}
.references-wrapper caption {
  font-size: 16px;
  color: $black;
  margin: 0px 0 0px 0;
}
.outbound-references {
  margin-bottom: 30px;
}
.wide-split-button {
  min-width: 140px;
  text-align: center;
  margin: 0;
}
.action-cell {
  width: 100px;
}
.type-cell {
  width: 150px;
}
table.filelist td {
  padding-right: 25px;
}
td.title-cell {
  padding-top: 0;
  padding-bottom: 0;
  a {
    color: $link-color;
    max-width: 240px;
    display: inline-block;
    margin-top: 6px;
  }
}
@media screen and (max-width: 550px) {
  .type-cell {
    display: none;
  }
}
</style>
